import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';

export const converterValorByTaxa = (valor, taxa) => {
  if (!taxa) {
    return valor;
  }
  const currencyTaxa = currency(taxa, { precision: DEFAULT_PRECISION });
  const currencyValue = currency(valor, { precision: DEFAULT_PRECISION });
  return currencyTaxa.multiply(currencyValue).value;
};

export default {
  converterValorByTaxa,
};
